import {AntdErrorMessage} from '../../../../../../../../component/antd-error-message/antd-error-message';
import {AddButton} from '../../../../../../../../layout/add-button/add-button';
import {Locale} from '../../../../../../../../provider/locale/localization';
import {TimeRangeType} from '../../../../../../../../service/company-v2/types/company-working-time-type';
import {classNames} from '../../../../../../../../util/css';

import {BreakTimeItem} from './break-time-item/break-time-item';
import * as styles from './break-time-list.scss';

type PropsType = {
    className?: string;
    breakTimeList: Array<TimeRangeType>;
    setBreakTimeList: (breakTimeList: Array<TimeRangeType>) => void;
    errorMessage?: Record<number, TimeRangeType>;
};

export function BreakTimeList(props: PropsType): JSX.Element {
    const {className, breakTimeList, setBreakTimeList, errorMessage} = props;

    const fullClassName = classNames(styles.BreakTimeList, className);
    const isBreakTimeListEmpty = breakTimeList.length === 0;

    function handleAddBreakTime() {
        setBreakTimeList([...breakTimeList, {}]);
    }

    function updateBreakTime(oldBreakTime: TimeRangeType, newBreakTime: TimeRangeType) {
        const newBreakTimeList = [...breakTimeList];

        newBreakTimeList[breakTimeList.indexOf(oldBreakTime)] = newBreakTime;

        setBreakTimeList(newBreakTimeList);
    }

    function deleteBreakTime(breakTime: TimeRangeType) {
        const newBreakTimeList = [...breakTimeList];

        newBreakTimeList.splice(newBreakTimeList.indexOf(breakTime), 1);

        setBreakTimeList(newBreakTimeList);
    }

    return (
        <div className={fullClassName}>
            {breakTimeList.map((breakTime: TimeRangeType, index: number) => {
                return (
                    <BreakTimeItem
                        breakTime={breakTime}
                        deleteBreakTime={deleteBreakTime}
                        errorMessage={errorMessage?.[index]}
                        key={`${String(index)}-${JSON.stringify(breakTime)}`}
                        prevBreakTime={breakTimeList[index - 1] || null}
                        updateBreakTime={updateBreakTime}
                    />
                );
            })}
            <AddButton
                className={styles.BreakTimeList_breakTime__addBreak}
                key={String(isBreakTimeListEmpty)}
                onClick={handleAddBreakTime}
                type="link"
            >
                <Locale stringKey="COMPANY_FORM__WORKING_TIME__BUTTON__ADD_BREAK" />
            </AddButton>

            {errorMessage && Array.isArray(errorMessage) && <AntdErrorMessage>{errorMessage}</AntdErrorMessage>}
        </div>
    );
}
